import React from 'react'

import { providers, providersList, tiers } from '@signals'
import { BACKEND_APIS } from '@constants'
import { AppProvidersAutocomplete } from '@components'
import { batch } from '@preact/signals-react'
import { chainFinish } from '@components/NewCommonFilters/@services/chainFinish'


export default function AppCommonFiltersProvidersAutocomplete({ onOptions, ...props }) {
	return <AppProvidersAutocomplete
		value={providers.value}
		onChange={e => batch(() => {
			providers.value = e.target.value
			if (!providers.value?.length && e.target.value?.length === 1) {
				tiers.value = null
			}
		})}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/providers`}
		onFinishAjax={chainFinish(options => providersList.value = options.map(p => p.value), onOptions)}
		limitTags={5}
		{...props}
	/>
}